import { WebComponent } from '@cian/mf-registry/browser';
import * as React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';

import { Application } from '../../../shared/containers/Application';
import { IReduxStore } from '../../../shared/types/redux';
import { IApplicationContext } from '../../../shared/types/application';

export function createFeedbackFormConstructor(
  context: IApplicationContext,
  store: IReduxStore,
): CustomElementConstructor {
  class FeedbackForm extends WebComponent {
    protected microfrontendName = context.config.getStrict<string>('projectName');
    protected imageVersion = context.config.getStrict<string>('version.commit');
    protected runtimeName = '/v1/get-feedback-form-microfrontend/';

    public async render() {
      const reactElement = <Application {...this.props} context={context} reduxStore={store} />;

      if (this.shouldHydrate) {
        hydrateRoot(this, reactElement);
      } else {
        createRoot(this).render(reactElement);
      }
    }
  }

  return FeedbackForm;
}
